<template>
  <v-container
    id="mainTable"
    data-component-id="reprise-table-layout"
    class="pa-0"
    fluid
  >
    <v-row
      dense
      class="ma-0"
    >
      <v-col
        cols="3"
        class="pa-0 z1"
        style="flex: 0 0 376px; min-width: 376px;"
      >
        <v-skeleton-loader
          :loading="isLoading"
          type="table"
          :types="{
            'table': 'table-tbody',
            'table-tbody': 'table-row-divider@14',
            'table-row-divider': 'table-row, divider',
            'table-row': 'table-cell@4',
            'table-cell': 'text'
          }"
          class="skeleton-loader--left"
        >
          <slot name="left-section" />
        </v-skeleton-loader>
      </v-col>

      <v-col
        data-component-id="table-reprise"
        class="
          overflow-x-auto no-scroll
          pa-0 border-left
        "
        style="--_border-left-color: var(--v-lightGray-darken1); --_border-left-width: 1px;"
        @scroll="syncRepriseScroll($event.target)"
      >
        <v-skeleton-loader
          data-component-id="skeleton-loader--right"
          :loading="isLoading"
          type="table"
          :types="{
            'table': 'table-tbody',
            'table-tbody': 'table-row-divider@14',
            'table-row-divider': 'table-row, divider',
            'table-row': `table-cell@${ sessionCount + 1 }`,
            'table-cell': 'text'
          }"
        >
          <slot name="right-section" />
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { onUpdated, watch, computed } from '@vue/composition-api';

import { syncRepriseScroll } from '@/helpers/utils';

import store from '@/store';

export default {
  name: 'RepriseTableLayout',
  props: {
    isLoading: { type: Boolean, default: false },
    sessionCount: { type: Number, default: 0 }
  },
  setup () {

    const isRepriseTab = computed(() => store.state.currentTab === 'reprise');

    const getContentTabElement = () => (document.getElementById('contentTypeCalendar'));
    
    const updateReprisePlannerContentHeight = () => {
      const height = document.querySelector('[data-component-id="reprise-planner-layout"]')?.offsetHeight || null;
      if (!height) return;

      const tabContent = getContentTabElement();
      if (!tabContent) return;

      tabContent.style.height = `calc(100% - (${ height }px + 72px + 2px))`;
    };

    watch(
      () => isRepriseTab.value,
      (val) => {
        if (val) {
          updateReprisePlannerContentHeight();
        } else {
          // Reset height when leaving the tab
          const tabContent = getContentTabElement();
          if (tabContent) tabContent.style.height = 'auto';
        }
      },
      { immediate: true }
    );

    onUpdated(() => {
      updateReprisePlannerContentHeight();
    });

    return { syncRepriseScroll };
  }
};
</script>

<style>
  [data-component-id="reprise-table-layout"] {
    .v-skeleton-loader {
      .v-skeleton-loader__table-tbody {
        padding-top: 36px; /* it wont overlap with the table header */
        .v-skeleton-loader__table-row {
          justify-content: unset;
          gap: 4px;

          .v-skeleton-loader__table-cell  {
            height: 30px;
          }
        }
      }
      .v-skeleton-loader__divider {
        display: none;
      }
      &.skeleton-loader--left .v-skeleton-loader__table-tbody {
        padding-inline: 4px;

        .v-skeleton-loader__table-cell {
          width: 100%;
        }
      }
      &[data-component-id="skeleton-loader--right"] {
        max-width: var(--right-section-width);

        overflow: unset;

        .v-skeleton-loader__bone {
          overflow: unset;
        }
        .v-skeleton-loader__table {
          .v-skeleton-loader__table-tbody {
            padding-inline: 0;
            .v-skeleton-loader__table-cell:first-child {
              padding-left: 4px;
            }
            .v-skeleton-loader__table-cell:not(:last-child) {
              min-width: 312px; /* [300 (session card) + 16 (sessions gap)] - 4px (skeleton ngap) */
              max-width: 312px;
              width: 100%;
            }
            .v-skeleton-loader__table-cell:last-child {
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>